import React from "react";
import SectionHead from "../ui/SectionHead";

export default function MultiOptionsStep({ step, values = [], onToggle, onContinue }) {
  const selected = new Set(values);

  return (
    <div>
      <SectionHead title={step.subtitle} subtitle="Mehrfachauswahl möglich." />

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {step.options.map((opt) => {
          const isOn = selected.has(opt.key);

          return (
            <button
              key={opt.key}
              type="button"
              onClick={() => onToggle(opt.key)}
              className={[
                "w-full rounded-2xl border bg-white p-4 text-left shadow-sm transition",
                "hover:-translate-y-0.5 hover:shadow-md",
                isOn ? "border-emerald-400 ring-4 ring-emerald-500/10" : "border-gray-200",
              ].join(" ")}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-sm font-semibold text-slate-900">{opt.label}</div>
                  {opt.subtitle ? <div className="mt-1 text-xs text-slate-600">{opt.subtitle}</div> : null}
                </div>

                <span
                  className={[
                    "mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full border text-xs font-bold",
                    isOn ? "border-emerald-400  text-[#8ec700]" : "border-gray-200 bg-white text-slate-400",
                  ].join(" ")}
                >
                  {isOn ? "✓" : "+"}
                </span>
              </div>
            </button>
          );
        })}
      </div>

      <div className="mt-6 flex items-center justify-between">
        <div className="text-xs text-slate-500">
          Ausgewählt: <span className="font-semibold text-slate-800">{values.length}</span>
        </div>

        <button
          type="button"
          onClick={onContinue}
          className="inline-flex items-center justify-center rounded-xl bg-[#0b2b40] px-6 py-3 text-sm font-semibold text-white shadow-sm shadow-emerald-600/20 hover:bg-[#0b2b40]/90"
        >
          Weiter
        </button>
      </div>
    </div>
  );
}
